import { createTUID } from "@buildwithflux/models";
export function isTerminalEqual(a, b) {
    return createTUID(a) === createTUID(b);
}
export function makeSegmentId(vertexIds) {
    // Sort before joining to ensure the same id no matter which order the vertices are specified in.
    return [...vertexIds].sort().join("__");
}
export function splitSegmentId(segmentId) {
    const vertexIds = segmentId.split("__");
    if (vertexIds.length !== 2)
        return undefined;
    return vertexIds;
}
//# sourceMappingURL=helpers.js.map